package music.jammers.client.shared.component

import music.jammers.client.shared.event.domain.model.ValidationError
import music.jammers.client.shared.event.domain.model.ValidationErrorValue

data class FieldValidationState(
    private val validationErrorMap: Map<String, ValidationError> = mutableMapOf(),
) {

    val errors: Map<String, ValidationError> get() = validationErrorMap

    fun addError(error: ValidationError): FieldValidationState {
        val mutable = validationErrorMap.toMutableMap()
        mutable[error.fieldName] = error

        return copy(
            validationErrorMap = mutable
        )
    }

    fun getValidationError(fieldName: String): ValidationErrorValue? =
        validationErrorMap[fieldName]?.value

    fun resetError(fieldName: String): FieldValidationState {
        val mutable = validationErrorMap.toMutableMap()
        mutable.remove(fieldName)

        return copy(
            validationErrorMap = mutable,
        )
    }
}